module.exports = __webpack_public_path__ + "img/experience.8f4f7497.jpg";